import React from 'react'

const NotFound = () => {
  return (
    <div>
        <div>
      <h2>404 Not Found</h2>
      <p>Sorry, the page you are looking for does not exist.</p>
    </div>
    </div>
  )
}

export default NotFound